import React, { Fragment, useState } from 'react';
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/business/Footer/Footer';
import Bg from '../../images/backgrounds/over_ons_image.webp';
import ModalVideo from 'react-modal-video'
import PolicySection from './Policy';
import WhyUs from './WhyUs';
import TeamSection from '../../components/TeamSection/TeamSection';
import { Helmet } from "react-helmet-async";

const AboutUsPage = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
            <Header />
            <main className="page_content">
                <PageTitle
                    pageTitle={'Over Ons'}
                    bgImage={Bg}
                />
                <section className="intro_about_section section_space bg-light" >
                    <div className="container">
                        <div className="heading_block mb-0">
                            <div className="row justify-content-lg-between">
                                <div className="col-lg-4">
                                    <h2 className="heading_text mb-0">
                                        Wie zijn wij?
                                    </h2>
                                </div>
                                <div className="col-lg-6">
                                    <p className="heading_description mb-0">
                                        Praeventor is opgericht door twee gedreven cybersecurity- en cloud-studenten aan de Hogeschool Utrecht die hun passie voor digitale veiligheid en innovatie wilden omzetten in impact. Met een scherp oog voor de nieuwste dreigingen en een solide achtergrond in cloudtechnologie, helpen wij organisaties om proactief beveiligingsrisico's te identificeren en te beheersen. Onze missie is om bedrijven op een laagdrempelige en effectieve manier weerbaar te maken tegen cyberaanvallen en gegevenslekken.

                                        Of het nu gaat om preventie, educatie of hands-on beveiligingsoplossingen, bij Praeventor staan wij klaar om jouw organisatie sterker en veiliger te maken in het digitale tijdperk.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <WhyUs />
                <PolicySection />
                {/*<FeaturesSection />*/}
                <TeamSection />

                {/*<CtaSection />*/}
            </main>
            <Footer />
            <Scrollbar />
            <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="7e90gBu4pas" onClose={() => setOpen(false)} />
        </Fragment>
    )
};
export default AboutUsPage;
